import { render, staticRenderFns } from "./properties-component-border.vue?vue&type=template&id=61938bd7&scoped=true"
import script from "./properties-component-border.vue?vue&type=script&lang=js"
export * from "./properties-component-border.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61938bd7",
  null
  
)

export default component.exports